import DateDisplay from "components/datetime/DateDisplay";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import {DevicesModels} from "site-apps/devices/DevicesModels";

const TableFirmware = ({items, itemsShow, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(e.currentTarget.dataset.idx);
        } else {
            items.current.removeFromChosen(e.currentTarget.dataset.idx);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "128px",
        backgroundColor: "white",
    };
    console.log(itemsShow);

    return (
        <>
            <div className="col-12">
                <table className="table table-striped table-sticky-horizontal">
                    <thead>
                        <tr>
                            <th key="-1" style={{width: "", ...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="all"
                                    checked={checkAll}
                                    onChange={handleCheckAll}
                                />
                            </th>
                            <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                        </tr>
                    </thead>
                    <tbody>
                        {itemsShow.map((item) => (
                            <tr key={item.id} data-idx={item.id} onChange={onClick}>
                                <td>
                                    <input
                                        type="checkbox"
                                        name="checkboxContainer"
                                        key={item.id}
                                        data-idx={item.id}
                                        defaultChecked={items.current.chosen.includes(item.id)}
                                        readOnly={true}
                                    />
                                </td>
                                <td>{item.name}</td>
                                <td>
                                    <DateDisplay date={item.create_at} format="DD-MM-YYYY HH:mm" title={true} />
                                </td>
                                <td>{DevicesModels.MODELS[item.device_model]?.mode || item.device_model}</td>
                                <td>{item.version}</td>
                                <td>{item.size}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TableFirmware;
